<div class="header">
  <h1>Choose Block</h1>
  <div class="search-and-toggle">
    <mat-form-field appearance="outline">
      <mat-label>Search</mat-label>
      <mat-icon matIconPrefix>search</mat-icon>
      <input #searchInput type="text" matInput [(ngModel)]="query" />
    </mat-form-field>
    <mat-chip-listbox multiple>
      <mat-chip-option
        [selected]="showCategories"
        (click)="showCategories = !showCategories"
        selectable="true"
        color="primary">
        Categories
      </mat-chip-option>
      <mat-chip-option
        [selected]="showPreviews"
        (click)="showPreviews = !showPreviews"
        selectable="true"
        color="primary">
        Previews
      </mat-chip-option>
    </mat-chip-listbox>
  </div>
</div>

@if (showCategories) {
  <mat-accordion class="category">
    @for (category of categorizedBlockTypes.categorizedBlocks; track category.category.id) {
      <mat-expansion-panel hideToggle [expanded]="$index === 0">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ category.category.label }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="block-list">
          @for (block of category.blocks; track block; let i = $index) {
            <ng-container *ngTemplateOutlet="blockButton; context: { block, i }"></ng-container>
          }
        </div>
      </mat-expansion-panel>
    }
    @if (categorizedBlockTypes.uncategorizedBlocks.length > 0) {
      <mat-expansion-panel hideToggle>
        <mat-expansion-panel-header>
          <mat-panel-title>
            Uncategorized Blocks
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="block-list">
          @for (block of categorizedBlockTypes.uncategorizedBlocks; track block; let i = $index) {
            <ng-container *ngTemplateOutlet="blockButton; context: { block, i }"></ng-container>
          }
        </div>
      </mat-expansion-panel>
    }
  </mat-accordion>
} @else {
  <div class="block-list">
    @for (block of allBlockTypes; track block; let i = $index) {
      <ng-container *ngTemplateOutlet="blockButton; context: { block, i }"></ng-container>
    }
  </div>
}

<ng-template #blockButton let-block="block" let-i="i">
  <button class="block-type" [class.has-preview]="showPreviews" (click)="insert(block)" [class.selected]="selected === i">
    <div class="block-type-label">
      @if (block.icon) {
        <mat-icon>{{ block.icon }}</mat-icon>
      }
      {{block.label}}
    </div>
    @if (showPreviews) {
      <tyt-content-block-preview [block]="block" />
    }
  </button>
</ng-template>
